export var REWARD_CENTER_EVENT_TYPES = {
  ENTER_REWARD_CENTER_SCREEN: 'ENTER_REWARD_CENTER_SCREEN',
  OPEN_REWARD_CENTER_CATEGORY: 'OPEN_REWARD_CENTER_CATEGORY',
  OPEN_REWARD_CENTER_OFFER: 'OPEN_REWARD_CENTER_OFFER'
};